import { Classificazione } from '../../common/models/classificazione';
import { Parte } from '../../common/models/parte';
import { TipoPratica } from '../../common/models/tipologiche/tipo-pratica';
import { CriteriUtente } from './criteri-utente';
import { SmartCriteriRicerca } from './smartCriteriRicerca';
import { AutoritaGiudiziaria } from './tipologiche/autorita-giudiziaria';
import { Oggetto } from './tipologiche/oggetto';
import { Provenienza } from './tipologiche/provenienza';
import { SedeTerritoriale } from './tipologiche/sede-territoriale';
import { StatoEntita } from './tipologiche/stato-entita';
import { TipoAtto } from './tipologiche/tipo-atto';
import { TipoFascicolo } from './tipologiche/tipo-fascicolo';
import { TipoScadenza } from './tipologiche/tipo-scadenza';
import { TipoVisibilita } from './tipologiche/tipo-visibilita';


export class SearchCriteria {
  searchText: string;      // testo libero - full text sui documenti
  parte: Parte;            // selezionata da una combo-box tra quelle con categoria controparte o controparte primaria
  soloContropartePrimaria: boolean;    // cerca solo controparte primaria
  posizionePratica: string;            // testo libero che matcha sulla posizione pratica
  definita: boolean;                   // a front-end devono comparire 3 valori: definite / pendenti / entrambe
  criteriUtente: CriteriUtente;
  soggetto: Oggetto;
  classificazione: Classificazione;
  tipoPratica: TipoPratica;
  statoPratica: StatoEntita;
  autoritaGiudiziaria: string;
  autoritaGiudiziariaDesc: string;
  sedeAutorita: string;
  sedeAutoritaDesc: string;
  inizioFascicoloDataDa: number;
  inizioFascicoloDataA: number;
  listaSmart: SmartCriteriRicerca;
  tipoVisibilita: TipoVisibilita;
  dateTo!: number;
  dateFrom!: number;
  dateCreationTo!: number;
  dateCreationFrom!: number;
  visibilita!: string;
  tipoScadenza: TipoScadenza;
  annoRuolo: string;
  numeroRuolo: string;
  codice: string;
  tipoAtto: TipoAtto;
  provenienza: Provenienza;
  dataNotificaDa: number;
  dataNotificaA: number;
  dataNotificaFascicoloDa: number;
  dataNotificaFascicoloA: number;
  tipoFascicolo:TipoFascicolo;
  descrizioneOggetto: string;
}
